export const weightData = {
  limit: 10,
  skip: 0,
  total: 1,
  data: [
    {
      id: 1,
      value: 174,
      unitOfMeasurement: 'lb',
      priority: 3,
      userId: 173,
      dateTime: '2021-01-26T04:20:43.854Z',
      variable: {
        id: 49,
        name: 'weight',
        value: null,
        type: 'integer',
        unitType: 'mass',
      },
      createdAt: '2020-11-14T13:41:03.711Z',
      updatedAt: '2020-11-14T13:41:03.711Z',
    },
    {
      id: 2,
      value: 168,
      unitOfMeasurement: 'lb',
      priority: 4,
      userId: 173,
      dateTime: '2021-01-16T09:16:52.302Z',
      variable: {
        id: 49,
        name: 'weight',
        value: null,
        type: 'integer',
        unitType: 'mass',
      },
      createdAt: '2020-10-31T12:19:22.653Z',
      updatedAt: '2020-10-31T12:19:22.653Z',
    },
    {
      id: 3,
      value: 160,
      unitOfMeasurement: 'lb',
      priority: 1,
      userId: 173,
      dateTime: '2021-01-06T09:43:25.715Z',
      variable: {
        id: 49,
        name: 'weight',
        value: null,
        type: 'integer',
        unitType: 'mass',
      },
      createdAt: '2021-01-06T09:44:12.676Z',
      updatedAt: '2021-01-06T09:44:12.676Z',
    },
  ],
};

export const addWeight = [
  {
    id: 4096,
    value: {
      value: '111.00',
    },
    priority: '4',
    dateTime: '2021-02-18T13:10:45.265Z',
    archive: false,
    migratedAt: null,
    createdAt: '2021-02-18T13:10:50.235Z',
    updatedAt: '2021-02-18T13:10:50.235Z',
    userId: 173,
    createdBy: 173,
    updatedBy: 173,
    variableId: 49,
    vitalId: null,
  },
  true,
];
export const singlePatientMedicalData = {
  allergies: [],
  diagnosis: [
    {
      name: 'Bulimia nervosa',
      id: 400,
      updatedAt: '04/27/2021',
      source: '4',
      status: null,
      codes: null,
    },
  ],
  symptoms: [],
  medications: [
    {
      id: 92,
      updatedAt: '03/03/2021',
      name: 'METHADONE HYDROCHLORIDE',
      dosage: null,
      instructions: null,
      route: null,
      startDate: '06/03/2020',
      source: '4',
      codes: null,
    },
  ],
  variables: [
    {
      name: 'medications',
      id: 52,
    },
    {
      name: 'symptoms',
      id: 56,
    },
    {
      name: 'diagnosis',
      id: 55,
    },
    {
      name: 'allergies',
      id: 60,
    },
  ],
};
export const labResults = {
  count: 0,
  rows: [],
};
